import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilesForZipScorm2004Service {

  public adlcp_v1p3_xsd(): string {
    return `<?xml version = "1.0"?>
<xs:schema targetNamespace = "http://www.adlnet.org/xsd/adlcp_v1p3"
           xmlns:xs = "http://www.w3.org/2001/XMLSchema"
           xmlns = "http://www.adlnet.org/xsd/adlcp_v1p3"
           elementFormDefault = "qualified"
           version = "1.0">

   <xs:annotation>
      <xs:documentation>
          This file represents the W3C XML Schema Language Binding of the ADL namespaced elements for content packaging extensions.
      </xs:documentation>
   </xs:annotation>

   <!-- *********************** -->
   <!-- ** Change History ** -->
   <!-- *********************** -->
   <xs:annotation>
      <xs:documentation>
      *************************************************************************
      *                           Change History                              *
      *************************************************************************
      2003-18-09  Initial creation.
      2003-19-09  Removed the restriction of the 255 character maximum length
                  on the dataFromLMS
      2004-01-06  Added completionThreshold to the ADL CP namespace
      2004-23-01  Final edits in preparation for release
      2006-02-06  Removed persistState, change type of the locationType from
                  xs:string to xs:anyURI
      *************************************************************************
      </xs:documentation>
   </xs:annotation>

   <xs:element name = "location" type = "locationType"/>
   <xs:element name = "dataFromLMS" type = "dataFromLMSType"/>
   <xs:element name = "timeLimitAction" type = "timeLimitActionType"/>
   <xs:element name = "completionThreshold" type = "completionThresholdType" />

   <!-- ADL Extension to the IMS Content Packaging XSD -->
   <xs:attribute name = "scormType">
      <xs:simpleType>
         <xs:restriction base = "xs:string">
            <xs:enumeration value = "sco"/>
            <xs:enumeration value = "asset"/>
         </xs:restriction>
      </xs:simpleType>
   </xs:attribute>

   <xs:simpleType name = "locationType">
      <xs:restriction base = "xs:anyURI"/>
   </xs:simpleType>

   <xs:simpleType name = "dataFromLMSType">
      <xs:restriction base = "xs:string"/>
   </xs:simpleType>

   <xs:simpleType name = "timeLimitActionType">
      <xs:restriction base = "xs:string">
         <xs:enumeration value = "exit,message"/>
         <xs:enumeration value = "exit,no message"/>
         <xs:enumeration value = "continue,message"/>
         <xs:enumeration value = "continue,no message"/>
      </xs:restriction>
   </xs:simpleType>

   <xs:simpleType name = "completionThresholdType">
       <xs:restriction base = "xs:decimal">
          <xs:minInclusive value = "0.0"/>
          <xs:maxInclusive value = "1.0"/>
       </xs:restriction>
   </xs:simpleType>

</xs:schema>
`;
  }

  public adlnav_v1p3_xsd(): string {
    return `<?xml version = "1.0"?>
<xs:schema targetNamespace = "http://www.adlnet.org/xsd/adlnav_v1p3"
           xmlns:xs = "http://www.w3.org/2001/XMLSchema"
           xmlns = "http://www.adlnet.org/xsd/adlnav_v1p3"
           elementFormDefault = "qualified"
           version = "1.0">

   <xs:annotation>
      <xs:documentation>
          This file represents the W3C XML Schema Language Binding of the ADL namespaced elements for navigation controls.
      </xs:documentation>
   </xs:annotation>

   <!-- *********************** -->
   <!-- ** Change History ** -->
   <!-- *********************** -->
   <xs:annotation>
      <xs:documentation>
      *************************************************************************
      *                          Change History                               *
      *************************************************************************
      2003-18-09  Initial creation.
      2004-23-01  Final edits in preparation for release
      2005-06-06  Added new hideLMSUI vocabulary token suspendAll, exitAll,
                  and abandonAll
      *************************************************************************
      </xs:documentation>
   </xs:annotation>

   <xs:element name = "presentation" type = "presentationType"/>

   <xs:element name = "navigationInterface" type = "navigationInterfaceType"/>

   <xs:element name = "hideLMSUI" type = "hideLMSUIType"/>

   <!-- Navigation Extension -->
   <xs:complexType name = "presentationType">
      <xs:sequence>
         <xs:element ref = "navigationInterface" minOccurs = "0" maxOccurs = "1"/>
      </xs:sequence>
   </xs:complexType>

   <xs:complexType name = "navigationInterfaceType">
      <xs:sequence>
         <xs:element ref = "hideLMSUI" minOccurs = "0" maxOccurs = "unbounded"/>
      </xs:sequence>
   </xs:complexType>

   <xs:simpleType name = "hideLMSUIType">
      <xs:restriction base = "xs:token">
         <xs:enumeration value = "abandon"/>
         <xs:enumeration value = "continue"/>
         <xs:enumeration value = "exit"/>
         <xs:enumeration value = "previous"/>
         <xs:enumeration value = "suspendAll"/>
         <xs:enumeration value = "exitAll"/>
         <xs:enumeration value = "abandonAll"/>
      </xs:restriction>
   </xs:simpleType>

</xs:schema>
`;
  }

  public adlseq_v1p3_xsd(): string {
    return `<?xml version = "1.0"?>
<xs:schema targetNamespace = "http://www.adlnet.org/xsd/adlseq_v1p3"
           xmlns:xs = "http://www.w3.org/2001/XMLSchema"
           xmlns = "http://www.adlnet.org/xsd/adlseq_v1p3"
           elementFormDefault = "qualified"
           version = "1.0">

   <xs:annotation>
      <xs:documentation>
          This file represents the W3C XML Schema Language Binding of the ADL namespaced elements for sequencing extensions.
      </xs:documentation>
   </xs:annotation>

   <!-- *********************** -->
   <!-- ** Change History ** -->
   <!-- *********************** -->
   <xs:annotation>
      <xs:documentation>
      *************************************************************************
      *                             Change History                            *
      *************************************************************************
      2003-18-09  Initial creation.
      2004-23-01  Final edits in preparation for release
      *************************************************************************
      </xs:documentation>
   </xs:annotation>

   <xs:element name = "constrainedChoiceConsiderations" type = "constrainChoiceConsiderationsType"/>

   <xs:element name = "rollupConsiderations" type = "rollupConsiderationsType"/>

   <xs:complexType name = "rollupConsiderationsType">
      <xs:attribute name = "requiredForSatisfied" default = "always" type = "rollupConsiderationType"/>
      <xs:attribute name = "requiredForNotSatisfied" default = "always" type = "rollupConsiderationType"/>
      <xs:attribute name = "requiredForCompleted" default = "always" type = "rollupConsiderationType"/>
      <xs:attribute name = "requiredForIncomplete" default = "always" type = "rollupConsiderationType"/>
      <xs:attribute name = "measureSatisfactionIfActive" default = "true" type = "xs:boolean"/>
   </xs:complexType>

   <xs:simpleType name = "rollupConsiderationType">
      <xs:restriction base = "xs:token">
         <xs:enumeration value = "always"/>
         <xs:enumeration value = "ifAttempted"/>
         <xs:enumeration value = "ifNotSkipped"/>
         <xs:enumeration value = "ifNotSuspended"/>
      </xs:restriction>
   </xs:simpleType>

   <xs:complexType name = "constrainChoiceConsiderationsType">
      <xs:attribute name = "preventActivation" default = "false" type = "xs:boolean"/>
      <xs:attribute name = "constrainChoice" default = "false" type = "xs:boolean"/>
   </xs:complexType>

   <xs:attribute name = "objectivesGlobalToSystem" default = "true" type = "xs:boolean" />

</xs:schema>
`;
  }

  public imscp_v1p1_xsd(): string {
    return `<?xml version = "1.0" encoding = "UTF-8"?>
<!--
	IPR, License and Distribution Notices
	This machine readable file is derived from IMS specification IMS Content Packaging XML Binding v1.1.4
	found at http://www.imsglobal.org/content/packaging/ and the original IMS schema binding or code base
	http://www.imsglobal.org/content/packaging/cpv1p1p4/imscp_bindv1p1p4.html.

	Recipients of this document are requested to submit, with their comments, notification of any relevant patent
	claims or other intellectual property rights of which they may be aware that might be infringed by the schema
	binding contained in this document.

	IMS takes no position regarding the validity or scope of any intellectual property or other rights that might be
	claimed to pertain to the implementation or use of the technology described in this document or the extent to
	which any license under such rights might or might not be available; neither does it represent that it has made
	any effort to identify any such rights. Information on IMS’s procedures with respect to rights in IMS specifications
	can be found at the IMS Intellectual Property Rights web page: http://www.imsglobal.org/ipr/imsipr_policyFinal.pdf.

	Copyright © IMS Global Learning Consortium 1999-2007. All Rights Reserved.

	License Notice for Users
	Users of products or services that include this document are hereby granted a worldwide, royalty-free,
	non-exclusive license to use this document.

	Distribution Notice for Developers
	Developers of products or services that provide distribution of this document as is or with modifications are
	required to register with the IMS community on the IMS website as described in the following two paragraphs:

	- If you wish to distribute this document as is, with no modifications, you are hereby granted permission to copy,
	display and distribute the contents of this document in any medium for any purpose without fee or royalty provided
	that you include this IPR, License and Distribution notice in its entirety on ALL copies, or portions thereof, that you
	make and you complete a valid license registration with IMS and receive an email from IMS granting the license.
	To register, follow the instructions on the IMS website: http://www.imsglobal.org/specificationdownload.cfm. Once
	registered you are granted permission to transfer unlimited distribution rights of this document for the purposes
	of third-party or other distribution of your product or service that incorporates this document as long as this IPR,
	License and Distribution notice remains in place in its entirety.

	- If you wish to create and distribute a derived work from this document, you are hereby granted permission to copy,
	display and distribute the contents of the derived work in any medium for any purpose without fee or royalty provided
	that you include this IPR, License and Distribution notice in its entirety on ALL copies, or portions thereof, that you
	make and you complete a valid profile registration with IMS and receive an email from IMS granting the license. To
	register, follow the instructions on the IMS website: http://www.imsglobal.org/profile/. Once registered you are
	granted permission to transfer unlimited distribution rights of the derived work for the purposes of third-party or
	other distribution of your product or service that incorporates the derived work as long as this IPR, License and
	Distribution notice remains in place in its entirety.

	The limited permissions granted above are perpetual and will not be revoked by IMS or its successors or assigns.

	THIS SPECIFICATION IS BEING OFFERED WITHOUT ANY WARRANTY WHATSOEVER, AND IN PARTICULAR,
	ANY WARRANTY OF NONINFRINGEMENT IS EXPRESSLY DISCLAIMED. ANY USE OF THIS SPECIFICATION
	SHALL BE MADE ENTIRELY AT THE IMPLEMENTER’S OWN RISK, AND NEITHER THE CONSORTIUM, NOR
	ANY OF ITS MEMBERS OR SUBMITTERS, SHALL HAVE ANY LIABILITY WHATSOEVER TO ANY IMPLEMENTER
	OR THIRD PARTY FOR ANY DAMAGES OF ANY NATURE WHATSOEVER, DIRECTLY OR INDIRECTLY, ARISING
	FROM THE USE OF THIS SPECIFICATION.
-->
<!--Generated by Turbo XML 2.3.1.100. Conforms to w3c http://www.w3.org/2001/XMLSchema-->
<xsd:schema xmlns = "http://www.imsglobal.org/xsd/imscp_v1p1"
	 targetNamespace = "http://www.imsglobal.org/xsd/imscp_v1p1"
	 xmlns:xsi = "http://www.w3.org/2001/XMLSchema-instance"
	 xmlns:xsd = "http://www.w3.org/2001/XMLSchema"
	 version = "IMS CP 1.1.4"
	 elementFormDefault = "qualified">
	<xsd:import namespace = "http://www.w3.org/XML/1998/namespace" schemaLocation = "http://www.w3.org/2001/xml.xsd"/>

	<!-- ******************** -->


	<!-- ** Change History ** -->


	<!-- ******************** -->
	<xsd:annotation>
	<xsd:documentation xml:lang = "en">DRAFT XSD for IMS Content Packaging version 1.1 DRAFT                </xsd:documentation>
	<xsd:documentation> Copyright (c) 2001 IMS GLC, Inc.                                                    </xsd:documentation>
	<xsd:documentation>2000-04-21, Adjustments by T.D. Wason from CP 1.0.                                   </xsd:documentation>
	<xsd:documentation>2001-02-22, T.D.Wason: Modify for 2000-10-24 XML-Schema version.                     </xsd:documentation>
	<xsd:documentation> Modified to support extension.                                                      </xsd:documentation>
	<xsd:documentation>2001-03-12, T.D.Wason: Change filename, target and meta-data namespaces              </xsd:documentation>
	<xsd:documentation> and meta-data filename.                                                             </xsd:documentation>
	<xsd:documentation> Add meta-data to itemType, fileType and organizationType.                           </xsd:documentation>
	<xsd:documentation> Do not define namespaces for xml in XML instances generated from this xsd.          </xsd:documentation>
	<xsd:documentation> Imports IMS meta-data xsd, lower case element names.                                </xsd:documentation>
	<xsd:documentation> This XSD provides a reference to the IMS meta-data root element as imsmd:record     </xsd:documentation>
	<xsd:documentation> If the IMS meta-data is to be used in the XML instance then the instance            </xsd:documentation>
	<xsd:documentation> must definean IMS meta-data prefix with a namespace.                                </xsd:documentation>
	<xsd:documentation> The meta-data targetNamespace should be used.                                       </xsd:documentation>
	<xsd:documentation> </xsd:documentation>
	<xsd:documentation>2001-03-20, Thor Anderson: Remove manifestref, change resourceref back to            </xsd:documentation>
	<xsd:documentation> identifierref, change manifest back to contained by manifest.                       </xsd:documentation>
	<xsd:documentation> </xsd:documentation>
	<xsd:documentation> --Tom Wason: manifest may contain _none_ or more manifests.                         </xsd:documentation>
	<xsd:documentation>2001-04-13 Tom Wason: corrected attirbute name structure.  Was misnamed type.        </xsd:documentation>
	<xsd:documentation> </xsd:documentation>
	<xsd:documentation>2001-05-14 Schawn Thropp: Made all complexType extensible with the group.any         </xsd:documentation>
	<xsd:documentation> Added the anyAttribute to all complexTypes.                                         </xsd:documentation>
	<xsd:documentation> Changed the href attribute on the fileType and resourceType to xsd:string           </xsd:documentation>
	<xsd:documentation> Changed the maxLength of the href, identifierref, parameters, structure             </xsd:documentation>
	<xsd:documentation> attributes to match the Information model.                                          </xsd:documentation>
	<xsd:documentation> </xsd:documentation>
	<xsd:documentation>2001-07-25 Schawn Thropp: Changed the namespace for the Schema of Schemas to     </xsd:documentation>
	<xsd:documentation> the 5/2/2001 W3C XML Schema Recommendation.                                         </xsd:documentation>
	<xsd:documentation> attributeGroup attr.imsmd deleted, was not used anywhere.                           </xsd:documentation>
	<xsd:documentation> Any attribute declarations that have use = "default"                                </xsd:documentation>
	<xsd:documentation> changed to use="optional" - attr.structure.req.                                     </xsd:documentation>
	<xsd:documentation> Any attribute declarations that have value="somevalue" changed to                   </xsd:documentation>
	<xsd:documentation> default="somevalue" - attr.structure.req (hierarchical).                            </xsd:documentation>
	<xsd:documentation> Removed references to IMS MD Version 1.1.                                           </xsd:documentation>
	<xsd:documentation> Modified attribute group "attr.resourcetype.req" to change use from optional        </xsd:documentation>
	<xsd:documentation> to required to match the information model.  As a result the default value          </xsd:documentation>
	<xsd:documentation> also needed to be removed                                                           </xsd:documentation>
	<xsd:documentation> Name change for XSD.  Changed to match version of CP Spec                           </xsd:documentation>
	<xsd:documentation> </xsd:documentation>
	<xsd:documentation> 2001-11-04 Chris Moffatt:                                                           </xsd:documentation>
	<xsd:documentation>  1. Refer to the xml namespace using the "x" abbreviation instead of "xml".         </xsd:documentation>
	<xsd:documentation>     This changes enables the schema to work with commercial XML Tools               </xsd:documentation>
	<xsd:documentation>  2. Revert to original IMS CP version 1.1 namespace.                                </xsd:documentation>
	<xsd:documentation>     i.e. "http://www.imsglobal.org/xsd/imscp_v1p1"                                  </xsd:documentation>
	<xsd:documentation>     This change done to support the decision to only change the XML namespace with  </xsd:documentation>
	<xsd:documentation>     major revisions of the specification i.e. where the information model or binding</xsd:documentation>
	<xsd:documentation>     changes (as opposed to addressing bugs or omissions). A stable namespace is     </xsd:documentation>
	<xsd:documentation>     necessary to the increasing number of implementors.                             </xsd:documentation>
	<xsd:documentation>  3. Changed name of schema file to "imscp_v1p1p3.xsd" and                           </xsd:documentation>
	<xsd:documentation>     version attribute to "IMS CP 1.1.3" to reflect minor version change             </xsd:documentation>
	<xsd:documentation>       </xsd:documentation>
	<xsd:documentation>2003-03-21 Schawn Thropp                                                             </xsd:documentation>
	<xsd:documentation>The following updates were made to the Version 1.1.3 "Public Draft" version:         </xsd:documentation>
	<xsd:documentation>  1. Updated name of schema file (imscp_v1p1.xsd) to match to IMS naming guideance   </xsd:documentation>
	<xsd:documentation>  2. Updated the import statement to reference the xml.xsd found at                  </xsd:documentation>
	<xsd:documentation>       "http://www.w3.org/2001/03/xml.xsd".  This is the current W3C schema          </xsd:documentation>
	<xsd:documentation>        recommended by the W3C to reference.                                         </xsd:documentation>
	<xsd:documentation>  3. Removed all maxLength's facets.  The maxLength facets was an incorrect binding  </xsd:documentation>
	<xsd:documentation>     implementation.  These lengths were supposed, according to the information      </xsd:documentation>
	<xsd:documentation>     model, to be treated as smallest permitted maximums.                            </xsd:documentation>
	<xsd:documentation>  4. Added the variations content model to support the addition in the information   </xsd:documentation>
	<xsd:documentation>     model.                                                                          </xsd:documentation>
	<xsd:documentation>            </xsd:documentation>
	<xsd:documentation> 2004-09-14 Alex Jackl, IMS Global:                                                           </xsd:documentation>
	<xsd:documentation>  1. Added "xmlns:xsi" declaration                    </xsd:documentation>
	<xsd:documentation>  2. Changed elementFormDefault to "qualified"           </xsd:documentation>
	<xsd:documentation>  3. Changed version attribute to "IMS CP 1.1.4" to reflect minor version change             </xsd:documentation>
	 <xsd:documentation>  4. Changed Process Content Values to "lax" from "strict"            </xsd:documentation>
	 <xsd:documentation>  5. Added attribute extension to  metadataType        </xsd:documentation>
	<xsd:documentation>  6. Corrected documentation title placement     </xsd:documentation>
	<xsd:documentation>  7. Changed xsd namespace schema location from "http://www.w3.org/2001/03/xml.xsd" to "http://www.w3.org/2001/xml.xsd" </xsd:documentation>
	<xsd:documentation>  8. Changed item multiplicity to "1 to many"</xsd:documentation>

	</xsd:annotation>

	<!-- ******************** -->


	<!-- ** Attribute Declarations** -->


	<!-- ******************** -->

	<xsd:attributeGroup name = "attr.base">
		<xsd:attribute ref = "xml:base"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.default">
		<xsd:attribute name = "default" type = "xsd:IDREF"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.href">
		<xsd:attribute name = "href" type = "xsd:anyURI"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.href.req">
		<xsd:attribute name = "href" use = "required" type = "xsd:anyURI"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.identifier.req">
		<xsd:attribute name = "identifier" use = "required" type = "xsd:ID"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.identifier">
		<xsd:attribute name = "identifier" type = "xsd:ID"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.isvisible">
		<xsd:attribute name = "isvisible" type = "xsd:boolean"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.parameters">
		<xsd:attribute name = "parameters" type = "xsd:string"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.identifierref">
		<xsd:attribute name = "identifierref" type = "xsd:string"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.identifierref.req">
		<xsd:attribute name = "identifierref" use = "required" type = "xsd:string"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.resourcetype.req">
		<xsd:attribute name = "type" use = "required" type = "xsd:string"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.structure.req">
		<xsd:attribute name = "structure" default = "hierarchical" type = "xsd:string"/>
	</xsd:attributeGroup>
	<xsd:attributeGroup name = "attr.version">
		<xsd:attribute name = "version" type = "xsd:string"/>
	</xsd:attributeGroup>
	<xsd:group name = "grp.any">
		<xsd:annotation>
		<xsd:documentation>Any namespaced element from any namespace may be included within an "any" element.  The namespace for the imported element must be defined in the instance, and the schema must be imported.  </xsd:documentation>
		</xsd:annotation>
		<xsd:sequence>
			<xsd:any namespace = "##other" processContents = "lax" minOccurs = "0" maxOccurs = "unbounded"/>
		</xsd:sequence>
	</xsd:group>



	<!-- ************************** -->


	<!-- ** Element Declarations ** -->


	<!-- ************************** -->

	<xsd:element name = "dependency" type = "dependencyType"/>
	<xsd:element name = "file" type = "fileType"/>
	<xsd:element name = "item" type = "itemType"/>
	<xsd:element name = "manifest" type = "manifestType"/>
	<xsd:element name = "metadata" type = "metadataType"/>
	<xsd:element name = "organization" type = "organizationType"/>
	<xsd:element name = "organizations" type = "organizationsType"/>
	<xsd:element name = "resource" type = "resourceType"/>
	<xsd:element name = "resources" type = "resourcesType"/>
	<xsd:element name = "schema" type = "schemaType"/>
	<xsd:element name = "schemaversion" type = "schemaversionType"/>
	<xsd:element name = "title" type = "titleType"/>

	<!-- ******************* -->


	<!-- ** Complex Types ** -->


	<!-- ******************* -->


	<!-- **************** -->


	<!-- ** dependency ** -->


	<!-- **************** -->

	<xsd:complexType name = "dependencyType">
		<xsd:sequence>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.identifierref.req"/>
		<xsd:anyAttribute namespace = "##other" processContents = "strict"/>
	</xsd:complexType>

	<!-- ********** -->


	<!-- ** file ** -->


	<!-- ********** -->

	<xsd:complexType name = "fileType">
		<xsd:sequence>
			<xsd:element ref = "metadata" minOccurs = "0"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.href.req"/>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>

	<!-- ********** -->


	<!-- ** item ** -->


	<!-- ********** -->

	<xsd:complexType name = "itemType">
		<xsd:sequence>
			<xsd:element ref = "title" minOccurs = "0"/>
			<xsd:element ref = "item" minOccurs = "0" maxOccurs = "unbounded"/>
			<xsd:element ref = "metadata" minOccurs = "0"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.identifier.req"/>
		<xsd:attributeGroup ref = "attr.identifierref"/>
		<xsd:attributeGroup ref = "attr.isvisible"/>
		<xsd:attributeGroup ref = "attr.parameters"/>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>

	<!-- ************** -->


	<!-- ** manifest ** -->


	<!-- ************** -->

	<xsd:complexType name = "manifestType">
		<xsd:sequence>
			<xsd:element ref = "metadata" minOccurs = "0"/>
			<xsd:element ref = "organizations"/>
			<xsd:element ref = "resources"/>
			<xsd:element ref = "manifest" minOccurs = "0" maxOccurs = "unbounded"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.identifier.req"/>
		<xsd:attributeGroup ref = "attr.version"/>
		<xsd:attribute ref = "xml:base"/>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>

	<!-- ************** -->


	<!-- ** metadata ** -->


	<!-- ************** -->

	<xsd:complexType name = "metadataType">
		<xsd:sequence>
			<xsd:element ref = "schema" minOccurs = "0"/>
			<xsd:element ref = "schemaversion" minOccurs = "0"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>

	<!-- ******************* -->


	<!-- ** organizations ** -->


	<!-- ******************* -->

	<xsd:complexType name = "organizationsType">
		<xsd:sequence>
			<xsd:element ref = "organization" minOccurs = "0" maxOccurs = "unbounded"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.default"/>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>

	<!-- ****************** -->


	<!-- ** organization ** -->


	<!-- ****************** -->

	<xsd:complexType name = "organizationType">
		<xsd:sequence>
			<xsd:element ref = "title" minOccurs = "0"/>
			<xsd:element ref = "item" maxOccurs = "unbounded"/>
			<xsd:element ref = "metadata" minOccurs = "0"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.identifier.req"/>
		<xsd:attributeGroup ref = "attr.structure.req"/>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>

	<!-- *************** -->


	<!-- ** resources ** -->


	<!-- *************** -->

	<xsd:complexType name = "resourcesType">
		<xsd:sequence>
			<xsd:element ref = "resource" minOccurs = "0" maxOccurs = "unbounded"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.base"/>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>

	<!-- ************** -->


	<!-- ** resource ** -->


	<!-- ************** -->

	<xsd:complexType name = "resourceType">
		<xsd:sequence>
			<xsd:element ref = "metadata" minOccurs = "0"/>
			<xsd:element ref = "file" minOccurs = "0" maxOccurs = "unbounded"/>
			<xsd:element ref = "dependency" minOccurs = "0" maxOccurs = "unbounded"/>
			<xsd:group ref = "grp.any"/>
		</xsd:sequence>
		<xsd:attributeGroup ref = "attr.identifier.req"/>
		<xsd:attributeGroup ref = "attr.resourcetype.req"/>
		<xsd:attributeGroup ref = "attr.base"/>
		<xsd:attributeGroup ref = "attr.href"/>
		<xsd:anyAttribute namespace = "##other" processContents = "lax"/>
	</xsd:complexType>


	<!-- ****************** -->


	<!-- ** Simple Types ** -->


	<!-- ****************** -->

	<xsd:simpleType name = "schemaType">
		<xsd:restriction base = "xsd:string"/>
	</xsd:simpleType>
	<xsd:simpleType name = "schemaversionType">
		<xsd:restriction base = "xsd:string"/>
	</xsd:simpleType>
	<xsd:simpleType name = "titleType">
		<xsd:restriction base = "xsd:string"/>
	</xsd:simpleType>

<!-- Copyright (2) 2004 IMS Global Learning Consortium, Inc. -->

</xsd:schema>`;
  }

  public imsss_v1p0_xsd(): string {
    return `<?xml version = "1.0" encoding = "UTF-8"?>
<!--Generated by Turbo XML 2.3.1.100. Conforms to w3c http://www.w3.org/2001/XMLSchema-->
<xs:schema xmlns = "http://www.imsglobal.org/xsd/imsss"
	 targetNamespace = "http://www.imsglobal.org/xsd/imsss"
	 xmlns:xs = "http://www.w3.org/2001/XMLSchema"
	 elementFormDefault = "qualified"
	 attributeFormDefault = "unqualified">
	<xs:include schemaLocation = "imsss_v1p0seqrule.xsd"/>
	<xs:include schemaLocation = "imsss_v1p0objective.xsd"/>
	<xs:include schemaLocation = "imsss_v1p0delivery.xsd"/>
	<xs:include schemaLocation = "imsss_v1p0random.xsd"/>
	<xs:include schemaLocation = "imsss_v1p0rollup.xsd"/>
	<xs:include schemaLocation = "imsss_v1p0control.xsd"/>
	<xs:include schemaLocation = "imsss_v1p0limit.xsd"/>
	<xs:include schemaLocation = "imsss_v1p0auxresource.xsd"/>
	<xs:element name = "sequencing" type = "sequencingType"
		 block = "#all">
		<xs:annotation>
			<xs:documentation>The root element for all sequencing tags.  This tag will usually appear as a child element to an IMS CP item tag.</xs:documentation>
		</xs:annotation>
	</xs:element>
	<xs:complexType name = "sequencingType">
		<xs:annotation>
			<xs:documentation>The type associated with any top-level sequencing tag</xs:documentation>
		</xs:annotation>
		<xs:sequence>
			<xs:element name = "controlMode" type = "controlModeType"
				 block = "#all" minOccurs = "0">
				<xs:annotation>
					<xs:documentation>non-exclusive definition of acceptable control-modes</xs:documentation>
				</xs:annotation>
			</xs:element>
			<xs:element name = "sequencingRules" type = "sequencingRulesType"
				 block = "#all" minOccurs = "0"/>
			<xs:element name = "limitConditions" type = "limitConditionsType"
				 block = "#all" minOccurs = "0"/>
			<xs:element name = "auxiliaryResources" type = "auxiliaryResourcesType"
				 block = "#all" minOccurs = "0"/>
			<xs:element name = "rollupRules" type = "rollupRulesType"
				 block = "#all" minOccurs = "0"/>
			<xs:element name = "objectives" type = "objectivesType"
				 block = "#all" minOccurs = "0">
<!--
				<xs:unique name = "uniqueGlobalObjective">
					<xs:selector xpath = ".//imsss:mapInfo[@writeSatisfiedStatus = 'true' or @writeNormalizedMeasure = 'true']"/>
					<xs:field xpath = "@targetObjectiveID"/>
				</xs:unique>
-->
			</xs:element>
			<xs:element name = "randomizationControls" type = "randomizationType"
				 block = "#all" minOccurs = "0"/>
			<xs:element name = "deliveryControls" type = "deliveryControlsType"
				 block = "#all" minOccurs = "0"/>
			<xs:any namespace = "##other" processContents = "strict" minOccurs = "0" maxOccurs = "unbounded"/>
		</xs:sequence>
		<xs:attribute name = "ID" type = "xs:ID"/>
		<xs:attribute name = "IDRef" type = "xs:IDREF"/>
	</xs:complexType>
	<xs:element name = "sequencingCollection"
		 block = "#all">
		<xs:complexType>
			<xs:sequence>
				<xs:element ref = "sequencing" maxOccurs = "unbounded"/>
			</xs:sequence>
		</xs:complexType>
	</xs:element>
</xs:schema>`;
  }

}


